var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandShake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5673 11.4172L20.25 12.5759L17.25 6.83067L19.5909 5.66024C19.7667 5.5723 19.9701 5.55695 20.1572 5.61749C20.3443 5.67802 20.5001 5.80961 20.5911 5.9839L22.8967 10.3992C22.9428 10.4875 22.9708 10.5841 22.9792 10.6834C22.9876 10.7826 22.9761 10.8825 22.9454 10.9773C22.9148 11.0721 22.8655 11.1598 22.8006 11.2353C22.7357 11.3108 22.6564 11.3727 22.5673 11.4172V11.4172Z",
    stroke: "#2C2E2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74945 12.4755L1.43217 11.3169C1.34308 11.2723 1.26376 11.2105 1.19883 11.135C1.13391 11.0594 1.08467 10.9717 1.05401 10.877C1.02334 10.7822 1.01186 10.6823 1.02023 10.583C1.0286 10.4838 1.05666 10.3872 1.10276 10.2989L3.40835 5.88357C3.49936 5.70927 3.65518 5.57768 3.84226 5.51714C4.02934 5.45661 4.23271 5.47196 4.40858 5.55989L6.74945 6.73033L3.74945 12.4755Z",
    stroke: "#2C2E2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 12.5758L18.75 14.3306L15.3003 17.7804C15.2087 17.8719 15.095 17.9382 14.9701 17.9728C14.8453 18.0074 14.7137 18.0091 14.588 17.9776L9.15458 16.6193C9.05266 16.5938 8.95724 16.5472 8.87448 16.4825L3.75 12.4753",
    stroke: "#2C2E2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7508 14.3309L14.6258 11.3309L13.4258 12.2309C12.9065 12.6204 12.2749 12.8309 11.6258 12.8309C10.9767 12.8309 10.3451 12.6204 9.82577 12.2309L9.31758 11.8498C9.23161 11.7853 9.16051 11.7031 9.10908 11.6088C9.05764 11.5144 9.02708 11.4101 9.01947 11.303C9.01185 11.1958 9.02735 11.0882 9.06493 10.9875C9.1025 10.8869 9.16127 10.7954 9.23725 10.7195L12.9061 7.0506C12.9757 6.98096 13.0584 6.92571 13.1494 6.88802C13.2404 6.85033 13.3379 6.83093 13.4364 6.83093H17.2508",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80469 6.73035L11.6159 5.3277C11.7878 5.2776 11.9719 5.29062 12.135 5.36442L15.3758 6.83083",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.9558L7.67443 19.2494C7.55977 19.2207 7.4535 19.1654 7.3643 19.0878L5.25 17.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandShake);
export default __webpack_public_path__ + "static/media/hand-shake.18360f20df905545131181861ba1d945.svg";
export { ForwardRef as ReactComponent };